// Challenge flow — shared state (localStorage-backed)
// Tracks: tier, size, platform across the 4-step wizard
// Allows going back/forward without losing progress

export type TierName = 'Beginner' | 'Mid' | 'Professional';
export type SizeKey = '50' | '100' | '150'; // $K
export type PlatformKey = 'Deepchart' | 'ATAS' | 'Deepdom' | 'Quantower' | 'Bookmap';

export interface ChallengeDraft {
  tier?: TierName;
  size?: SizeKey;
  platform?: PlatformKey;
  updatedAt?: number;
}

const STORAGE_KEY = 'fp_challenge_draft';

export function loadDraft(): ChallengeDraft {
  if (typeof window === 'undefined') return {};
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    return JSON.parse(raw);
  } catch {
    return {};
  }
}

export function saveDraft(d: ChallengeDraft) {
  if (typeof window === 'undefined') return;
  const next = { ...d, updatedAt: Date.now() };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
}

export function clearDraft() {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(STORAGE_KEY);
}

export function setTier(t: TierName) {
  const d = loadDraft();
  d.tier = t;
  saveDraft(d);
}
export function setSize(s: SizeKey) {
  const d = loadDraft();
  d.size = s;
  saveDraft(d);
}
export function setPlatform(p: PlatformKey) {
  const d = loadDraft();
  d.platform = p;
  saveDraft(d);
}
